import unescape from 'lodash.unescape';
import {APPLICATION_SETTINGS} from '@client/constants/applicationSettings';

const DEFAULT_HEADER_COLOR = '#3D586D';
const DEFAULT_BG_IMAGE = 'assets/img/background/loginbg_1.png';
const DEFAULT_SIDEBAR_COLOR = '#354552';

const DEFAULT_HEADER_FONT_COLOR = '#FFFFFF';
const DEFAULT_SIDEBAR_FONT_COLOR = '#FFFFFF';

const DEFAULT_SIDEBAR_STYLE = 'left';

export default class RiaSettings {
  // eslint-disable-next-line max-statements
  constructor() {
    this.fontSize = null;
    this.fontFamily = null;
    this.headerColor = null;
    this.loginBackground = null;
    this.disclaimer = APPLICATION_SETTINGS.riaFeatures.riaText.riaDisclaimer;
    this.sidebarColor = null;
    this.rectangleLogo = null;
    this.squareLogo = null;
    this.companyLegalName = null;
    this.favicon = null;
    this.headerFontColor = null;
    this.sidebarFontColor = null;
    this.phoneNumber = APPLICATION_SETTINGS.riaFeatures.riaInformation.riaPhoneNumber;
    this.emailAddress = APPLICATION_SETTINGS.riaFeatures.riaInformation.riaEmail;
    this.website = null;
    this.contactPage = null;
    this.additionalDisclaimer = null;
    this.sidebarStyle = null;
    this.wealthProjectionDisclaimer = null;
    this.rtqGaugeText = null;
    this.cdoParameter = null;
    this.buttonType = null;
    this.showAggregation = false;
    this.performanceReportDisclaimer = null;
    this.canLiquidateAccounts = false;
    this.congratulationImage = null;
    this.sidebarHoverColor = null;
    this.headerHoverColor = null;
    this.helpLogo = null;
    this.performanceReportDisclaimer = null;
    this.cdoWelcomeImage = null;
  }

  setRiaLogo(payload) {
    this.squareLogo = payload.riaSquareLogo;
    this.rectangleLogo = payload.riaRectangleLogo;
    this.favicon = payload.riaFavicon;
    this.helpLogo = payload.helpLogo;
  }

  setRiaImages(payload) {
    this.loginBackground = payload.riaBgImage || DEFAULT_BG_IMAGE;
    this.congratulationImage = payload.openAccountCongratulationsImage;
    this.cdoWelcomeImage = payload.cdoGetStartedImage;
  }

  setRiaDesignStyle(payload) {
    this.buttonType = payload.riaButtonType;
    this.fontFamily = payload.riaFontFamily;
    this.fontSize = payload.riaFontSize;
    this.headerColor =
      payload.riaHeaderColor === 'navbar-robustRIA-default' ? DEFAULT_HEADER_COLOR : payload.riaHeaderColor;
    this.headerFontColor =
      payload.riaHeaderFontColor && payload.riaHeaderFontColor !== 'default'
        ? payload.riaHeaderFontColor
        : DEFAULT_HEADER_FONT_COLOR;
    this.sidebarColor =
      payload.riaSidebarColor === 'sidebar-robustRIA-default' ? DEFAULT_SIDEBAR_COLOR : payload.riaSidebarColor;
    this.sidebarStyle = payload.riaSidebarStyle || DEFAULT_SIDEBAR_STYLE;
    this.sidebarHoverColor = payload.riaSidebarHoverColor;
    this.sidebarFontColor =
      payload?.riaSidebarFontColor === 'default' ? DEFAULT_SIDEBAR_FONT_COLOR : payload.riaSidebarFontColor;
    this.headerHoverColor = payload.riaHeaderHoverColor;
  }

  setRiaInformation(payload) {
    this.riaId = payload.riaId;
    this.enterpriseId = payload.enterpriseId;
    this.companyLegalName = payload.companyLegalName;
    this.companyName = payload.companyName;
    this.cdoParameter = payload.firmParameter;
    this.contactPage = payload.contactPageLink;
    this.phoneNumber = payload.riaPhoneNumber;
    this.emailAddress = payload.riaEmail;
  }

  setRiaText(payload) {
    if (payload.riaDisclaimer) {
      this.disclaimer = unescape(payload.riaDisclaimer);
    }

    this.performanceReportDisclaimer = payload.performanceReportDisclaimer;
    this.additionalDisclaimer = payload.additionalDisclaimer;
    this.rtqGaugeText = payload.rtqAnswerText;
    this.wealthProjectionDisclaimer = payload.wealthProjectionDisclaimer;
  }
}
